export default "__VITE_ASSET__3cde57c6__"